import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  IconWrapper,
  Content,
  Label,
  Value,
  TrendIndicator,
} from './MetricCard.styled';

const MetricCard = ({ icon, label, value, trend = null, loading = false }) => {
  return (
    <Card>
      <IconWrapper>
        <i className={`mdi ${icon}`} />
      </IconWrapper>
      <Content>
        <Label>{label}</Label>
        {loading ? (
          <Value>...</Value>
        ) : (
          <>
            <Value>{value}</Value>
            {trend && (
              <TrendIndicator positive={trend > 0}>
                <i className={`mdi mdi-arrow-${trend > 0 ? 'up' : 'down'}`} />
                {Math.abs(trend)}%
              </TrendIndicator>
            )}
          </>
        )}
      </Content>
    </Card>
  );
};

MetricCard.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  trend: PropTypes.number,
  loading: PropTypes.bool,
};

export default MetricCard;


